import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../../../core/helpers/default';

const name = 'signatoryEntryFields';

const reducersKeys = {
  getDefaultSignatoryFieldsRequest: 'getDefaultSignatoryFieldsRequest',
  getDefaultSignatoryFieldsSuccess: 'getDefaultSignatoryFieldsSuccess',
  getDefaultSignatoryFieldsFailure: 'getDefaultSignatoryFieldsFailure',
};

const initialState = {
  defaultSignatoryFields: {},
  loading: false,
  error: null,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getDefaultSignatoryFieldsRequest]: (state) => {
      state.loading = true;
      state.defaultSignatoryFields = [];
    },
    [reducersKeys.getDefaultSignatoryFieldsSuccess]: (state, { payload }) => {
      state.defaultSignatoryFields = payload.data;
      state.loading = false;
    },
    [reducersKeys.getDefaultSignatoryFieldsFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
  },
});

export const signatoryEntryFieldsReducers = createReducerNames(name, reducersKeys);
export const { actions } = slice;

export default slice.reducer;
